import { render } from "./archiveList.vue?vue&type=template&id=3a7bf7d8&scoped=true&ts=true"
import script from "./archiveList.vue?vue&type=script&lang=ts&config=true"
export * from "./archiveList.vue?vue&type=script&lang=ts&config=true"

import "./archiveList.vue?vue&type=style&index=0&id=3a7bf7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7bf7d8"]])

export default __exports__